var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoyaltyPerk2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 92 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#loyalty-perk-2_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#719C89",
  d: "M0 26.48h23.084v4.073H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  d: "M23.273 26.272c0-5.973-4.503-10.896-10.302-11.558l-.171-.172 4.655-4.654-1.164-1.164-3.83 3.83v-1.04a2.91 2.91 0 0 0 2.085-2.79H12.46v-2.91h7.903V0H2.909v5.818h7.903v2.91H8.727c0 1.321.88 2.433 2.085 2.789v1.04l-3.83-3.83-1.164 1.164 4.655 4.655-.172.17C4.503 15.38 0 20.3 0 26.273v1.733h23.273zm0 2.703H0V32h23.273z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#loyalty-perk-2_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#719C89",
  d: "M57.545 5.543h-1.15V2.638A2.64 2.64 0 0 0 53.758 0H35.104a2.64 2.64 0 0 0-2.638 2.638v2.905h-1.193v5.33h1.193v18.489A2.64 2.64 0 0 0 35.104 32h18.653a2.64 2.64 0 0 0 2.639-2.638v-18.49h1.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  d: "M57.545 5.543h-1.15V2.638A2.64 2.64 0 0 0 53.758 0H35.104a2.64 2.64 0 0 0-2.638 2.638v2.905h-1.193v5.33h1.193v18.489A2.64 2.64 0 0 0 35.104 32h18.653a2.64 2.64 0 0 0 2.639-2.638v-18.49h1.149zm-3.788-2.905v5.509h-2.533V5.543H48.85v2.604h-8.578V5.543h-2.374v2.604h-2.794V2.638zM37.018 29.362l1.671-8.466c.991-2.955 2.577-3.756 5.755-3.756s4.766.853 5.754 3.756l1.833 8.466zm15.892 0a1 1 0 0 0-.018-.185l-1.832-8.466q-.01-.049-.026-.097c-1.231-3.609-3.524-4.35-6.587-4.35-3.064 0-5.374.727-6.59 4.353q-.017.054-.03.108l-1.67 8.467a1 1 0 0 0-.015.17h-1.038V9.026h2.794v1.847h2.374V9.026h8.578v1.847h2.374V9.026h2.533v20.336z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#loyalty-perk-2_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#719C89",
  d: "M73.019 12.23H83.21v4.076H73.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B6638",
  d: "m91.166 29.112-.977-26.434h-1.71V0h-5.522v2.681H81.51l-.117 3.102h-5.583l-.113-3.102H74.12V0h-5.528v2.681h-1.579l-1.006 26.43h-.462V32h11.59v-2.888h-.463l-.32-8.695h4.483l-.33 8.694h-.398V32h11.59v-2.888zm-9.924-13.566h-5.79v-1.382h5.79z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "loyalty-perk-2_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h23.273v32H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "loyalty-perk-2_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M31.273 0h26.272v32H31.273z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "loyalty-perk-2_svg__c"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M65.545 0h26.148v32H65.545z"
})))));
export default SvgLoyaltyPerk2;